export const fieldTextStyles = {
  borderRadius: "5px",
  backgroundColor: "#fff",
  color: "#505050",
  fontSize: "14px",
  lineHeight: "38px",
  height: "38px",
  textAlign: "center",
  "& fieldset": {
    borderColor: "#505050",
  },
  "& input": {
    padding: "0 !important",
  },
};
